import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-sucesso-inclusao-cartao',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  templateUrl: './sucesso-inclusao-cartao.component.html',
  styleUrls: ['./sucesso-inclusao-cartao.component.css']
})
export class SucessoInclusaoCartaoComponent {

}
